<template>
    <div class="skeleton">
        <div v-for="line in lines" :key="`${line}-filter-skeleton`"></div>
    </div>
</template>

<script> 
    export default {
        data() {
            return {
                lines: 4
            }
        }
    }
</script>

<style scoped>
    .skeleton {
        display: flex;
        flex-direction: column;
        gap: 0.3rem;
        padding: 0rem 0.35rem 0.75rem 0.35rem;
    }
    .skeleton > div {
        position: relative;
        width: 100%;
        height: 10px;
        border-radius: 25px;
        background-color: #d9d9d9;
        overflow: hidden;
    }

    .skeleton > div::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
            to right,
            #d9d9d9 0%,
            #888b94 20%,
            #d9d9d9 40%,
            #d9d9d9 100%
        );
        background-size: 450px 400px;
        background-repeat: no-repeat;
        animation: shimmer 1.4s linear infinite;
    }

    @keyframes shimmer {
        0% {
            background-position: -450px 0px;
        }
        100% {
            background-position: 450px 0px;
        }
    }
</style>